var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.26 120.24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.51,42.2A60.09,60.09,0,1,0,6.8,87.76a3,3,0,0,1,.27,2.44C4.8,98,2.6,105.8.34,113.59c-.56,1.94-.51,3.72,1,5.23s3.35,1.62,5.35,1c7.83-2.28,15.69-4.5,23.53-6.78a2.7,2.7,0,0,1,2.17.27,59.34,59.34,0,0,0,27.09,6.89A65.22,65.22,0,0,0,73,118.82C107.19,111.51,128.06,75.62,117.51,42.2ZM72.86,109.31c-13.16,3.46-25.75,1.67-37.63-4.93a6.81,6.81,0,0,0-5.75-.71c-5.6,1.72-11.26,3.25-16.89,4.86-.31.09-.63.14-1.22.26C13,103.2,14.49,97.85,16,92.5c.21-.74.4-1.49.65-2.21a5.48,5.48,0,0,0-.58-4.83,47.86,47.86,0,0,1-6.34-18.4C7.67,50.32,12.53,35.82,24.46,23.93,34.92,13.51,47.77,8.76,62.5,9.28c23.38.84,43.67,18.72,47.65,41.86A50.72,50.72,0,0,1,72.86,109.31ZM66.24,60.14A6.14,6.14,0,1,1,60.18,54,6.08,6.08,0,0,1,66.24,60.14Zm-30.9,6.1a6.14,6.14,0,1,1,6.26-6A6.15,6.15,0,0,1,35.34,66.24ZM84.84,54a6.14,6.14,0,1,1-6.23,6A6.15,6.15,0,0,1,84.84,54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingComments);
export default __webpack_public_path__ + "static/media/Pending-Comments.1bfbadc6ca89fe12127b8a5118959bce.svg";
export { ForwardRef as ReactComponent };